/**
 * Lab results popup (snippets/ss-lab-popup.liquid).
 * Opens the dialog instead of navigating for in-page links to /pages/lab-results and for any
 * [data-lab-popup] element. Header/footer links and the link inside the dialog still navigate.
 * Browsers without <dialog> support just follow the link.
 */
(function () {
  function init() {
    var dlg = document.getElementById('ss-lab-popup');
    if (!dlg || dlg.dataset.ready) return;
    dlg.dataset.ready = '1';
    if (typeof dlg.showModal !== 'function') return;

    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      dlg.showModal();
      document.documentElement.classList.add('ss-lab-open');
    };
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('ss-lab-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    });
    // Close on the X or a click on the backdrop (the dialog itself, outside the box)
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-ss-lab-close]')) dlg.close();
    });

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = e.target.closest && e.target.closest('[data-lab-popup], a[href]');
      if (!t || dlg.contains(t)) return;
      if (!t.hasAttribute('data-lab-popup')) {
        var path;
        try { path = new URL(t.href, location.href).pathname; } catch (err) { return; }
        if (!/\/pages\/lab-results\/?$/.test(path)) return;
        if (t.closest('header, footer, .shopify-section-group-header-group, .shopify-section-group-footer-group, .c-footer')) return;
      }
      e.preventDefault();
      open();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
